//  Copyright (c) 2026 Molly Xue
//  Licensed under the MIT License
async function $ff61dd1a091f4213$export$e733acd7e07c0138(width, height, fps) {
    if (!navigator.mediaDevices?.getUserMedia) throw new Error('Browser API navigator.mediaDevices.getUserMedia is not available');
    const video = document.getElementById('webcam');
    video.width = width;
    video.height = height;
    video.muted = true;
    const stream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
            facingMode: 'user',
            width: width,
            height: height,
            frameRate: {
                max: fps
            }
        }
    });
    video.srcObject = stream;
    return new Promise((resolve)=>{
        video.onloadedmetadata = ()=>resolve(video);
    });
}
async function $ff61dd1a091f4213$export$d2b008984942555e(width, height, fps) {
    const video = await $ff61dd1a091f4213$export$e733acd7e07c0138(width, height, fps);
    video.play();
    return video;
}


let $2ca412f2b7fd875e$var$control = {
    state: null,
    grabWindowXPosition: null,
    grabWindowYPosition: null,
    handGrabXPoistion: null,
    handGrabYPosition: null,
    handX: [],
    handY: [],
    rollingAverage: 0
};
function $2ca412f2b7fd875e$export$8f7e70c35bef16dc(pinch, predictions) {
    if (predictions == undefined || predictions.length == 0) return;
    let prediction = predictions[0];
    if (pinch) {
        let x = prediction.annotations.indexFinger[3][0];
        let y = prediction.annotations.indexFinger[3][1];
        if ($2ca412f2b7fd875e$var$control.state != 'pinch') {
            $2ca412f2b7fd875e$var$control.grabWindowXPosition = window.scrollX;
            $2ca412f2b7fd875e$var$control.grabWindowYPosition = window.scrollY;
            $2ca412f2b7fd875e$var$control.handGrabXPoistion = x;
            $2ca412f2b7fd875e$var$control.handGrabYPosition = y;
            $2ca412f2b7fd875e$var$control.handX = [
                x,
                x,
                x,
                x,
                x
            ];
            $2ca412f2b7fd875e$var$control.handY = [
                y,
                y,
                y,
                y,
                y
            ];
            $2ca412f2b7fd875e$var$control.state = 'pinch';
        }
        // move window relative to grab
        $2ca412f2b7fd875e$var$control.handX[$2ca412f2b7fd875e$var$control.rollingAverage] = x;
        $2ca412f2b7fd875e$var$control.handY[$2ca412f2b7fd875e$var$control.rollingAverage] = y;
        $2ca412f2b7fd875e$var$control.rollingAverage = ($2ca412f2b7fd875e$var$control.rollingAverage + 1) % 5;
        var handDeltaY = $2ca412f2b7fd875e$var$control.handY.reduce((sum, v)=>sum + v, 0) / $2ca412f2b7fd875e$var$control.handY.length - $2ca412f2b7fd875e$var$control.handGrabYPosition;
        var handDeltaX = $2ca412f2b7fd875e$var$control.handX.reduce((sum, v)=>sum + v, 0) / $2ca412f2b7fd875e$var$control.handX.length - $2ca412f2b7fd875e$var$control.handGrabXPoistion;
        const scale = 10;
        window.scrollTo($2ca412f2b7fd875e$var$control.grabWindowXPosition + handDeltaX * scale, $2ca412f2b7fd875e$var$control.grabWindowYPosition - handDeltaY * scale);
    } else {
        if ($2ca412f2b7fd875e$var$control.state == 'pinch') console.log('unpinch');
        $2ca412f2b7fd875e$var$control.state = 'something';
    }
}


// ─────────────────────────────────────────────────────────
//  Maps raw camera coordinates → CSS screen coordinates
//  and moves the #virtual-cursor element.
//
//  Returns { screenX, screenY } so callers (renderVideo.js)
//  can forward the position to other gesture handlers.
// ─────────────────────────────────────────────────────────
const $e02e324ad509ad30$var$cursor = document.getElementById('virtual-cursor');
// Smoothing for the cursor itself (separate from gesture EMA)
let $e02e324ad509ad30$var$smoothCursor = null;
const $e02e324ad509ad30$var$CURSOR_EMA = 0.2; // 0 = frozen, 1 = raw
function $e02e324ad509ad30$export$4d7186f747f2fbe6(handX, handY, videoWidth, videoHeight) {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    // Camera is mirrored (scaleX(-1) in CSS), so flip X
    const x = (1 - handX / videoWidth) * vw;
    const y = handY / videoHeight * vh;
    return $e02e324ad509ad30$var$smoothMove(x, y);
}
function $e02e324ad509ad30$var$smoothMove(targetX, targetY) {
    // Smooth the cursor independently for a fluid feel
    if (!$e02e324ad509ad30$var$smoothCursor) $e02e324ad509ad30$var$smoothCursor = {
        x: targetX,
        y: targetX,
        targetY: targetY
    };
    else {
        $e02e324ad509ad30$var$smoothCursor.x = $e02e324ad509ad30$var$CURSOR_EMA * targetX + (1 - $e02e324ad509ad30$var$CURSOR_EMA) * $e02e324ad509ad30$var$smoothCursor.x;
        $e02e324ad509ad30$var$smoothCursor.y = $e02e324ad509ad30$var$CURSOR_EMA * targetY + (1 - $e02e324ad509ad30$var$CURSOR_EMA) * $e02e324ad509ad30$var$smoothCursor.y;
    }
    if ($e02e324ad509ad30$var$cursor) {
        $e02e324ad509ad30$var$cursor.style.left = `${$e02e324ad509ad30$var$smoothCursor.x}px`;
        $e02e324ad509ad30$var$cursor.style.top = `${$e02e324ad509ad30$var$smoothCursor.y}px`;
    }
    return {
        screenX: $e02e324ad509ad30$var$smoothCursor.x,
        screenY: $e02e324ad509ad30$var$smoothCursor.y
    };
}


// ─────────────────────────────────────────────────────────
//  clickByHandGesture.js  –  fist → open palm = click
// ─────────────────────────────────────────────────────────
let $10cf7727b597bd4a$var$clickControl = {
    state: 'idle',
    lastGestureTime: 0,
    fistAverage: {
        x: 0,
        y: 0
    },
    smoothAvg: null
};
const $10cf7727b597bd4a$var$EMA_ALPHA = 0.35; // smoothing factor for centroid
const $10cf7727b597bd4a$var$FIST_STABLE_MS = 180; // ms fist must be held before arming
const $10cf7727b597bd4a$var$MOVEMENT_STABLE_PX = 14; // px – max drift allowed while arming
const $10cf7727b597bd4a$var$COOLDOWN_MS = 800; // ms between successive clicks
// ── Fist thresholds ───────────────────────────────────────
// A fist = all four fingertips curled close to their MCP (knuckle) joints.
// We measure each fingertip→MCP distance; if ALL are below FIST_TIP_MCP_MAX
// the hand is considered a fist.
const $10cf7727b597bd4a$var$FIST_TIP_MCP_MAX = 80; // px – tip must be within this of its MCP
const $10cf7727b597bd4a$var$FIST_MIN_FINGERS = 4; // how many fingers must satisfy the above (thumb excluded)
// ── Open-palm threshold ───────────────────────────────────
// Open palm = fingertips spread far from the palm centre.
// We reuse the same spread metric as before.
const $10cf7727b597bd4a$var$OPEN_DISTANCE_THRESHOLD = 120; // px – max spread from centroid
let $10cf7727b597bd4a$var$lastClickTime = 0;
// ─────────────────────────────────────────────────────────
//  Helpers
// ─────────────────────────────────────────────────────────
/**
 * Returns true when the four fingers (index→pinky) are curled into a fist.
 * Strategy: each fingertip should be close to its own MCP (base knuckle).
 *
 * Handpose annotation indices used:
 *   [0] = MCP (knuckle),  [3] = fingertip
 */ function $10cf7727b597bd4a$var$isFist(annotations) {
    const fingers = [
        {
            mcp: annotations.indexFinger[0],
            tip: annotations.indexFinger[3]
        },
        {
            mcp: annotations.middleFinger[0],
            tip: annotations.middleFinger[3]
        },
        {
            mcp: annotations.ringFinger[0],
            tip: annotations.ringFinger[3]
        },
        {
            mcp: annotations.pinky[0],
            tip: annotations.pinky[3]
        }
    ];
    let curledCount = 0;
    for (const { mcp: mcp, tip: tip } of fingers){
        const dist = Math.hypot(tip[0] - mcp[0], tip[1] - mcp[1]);
        if (dist < $10cf7727b597bd4a$var$FIST_TIP_MCP_MAX) curledCount++;
    }
    return curledCount >= $10cf7727b597bd4a$var$FIST_MIN_FINGERS;
}
/**
 * Returns true when the hand is open (fingertips spread away from centroid).
 */ function $10cf7727b597bd4a$var$isOpenPalm(annotations) {
    const tips = [
        annotations.thumb[3],
        annotations.indexFinger[3],
        annotations.middleFinger[3],
        annotations.ringFinger[3],
        annotations.pinky[3]
    ];
    const avgX = tips.reduce((s, p)=>s + p[0], 0) / 5;
    const avgY = tips.reduce((s, p)=>s + p[1], 0) / 5;
    let maxDist = 0;
    for (const tip of tips){
        const d = Math.hypot(tip[0] - avgX, tip[1] - avgY);
        if (d > maxDist) maxDist = d;
    }
    return maxDist > $10cf7727b597bd4a$var$OPEN_DISTANCE_THRESHOLD;
}
function $10cf7727b597bd4a$export$388ce54039214433(prediction) {
    const now = Date.now();
    const ann = prediction.annotations;
    // ── Smooth the wrist position for stability checks ────
    const wrist = prediction.landmarks[0]; // [x, y, z]
    if (!$10cf7727b597bd4a$var$clickControl.smoothAvg) $10cf7727b597bd4a$var$clickControl.smoothAvg = {
        x: wrist[0],
        y: wrist[1]
    };
    else {
        $10cf7727b597bd4a$var$clickControl.smoothAvg.x = $10cf7727b597bd4a$var$EMA_ALPHA * wrist[0] + (1 - $10cf7727b597bd4a$var$EMA_ALPHA) * $10cf7727b597bd4a$var$clickControl.smoothAvg.x;
        $10cf7727b597bd4a$var$clickControl.smoothAvg.y = $10cf7727b597bd4a$var$EMA_ALPHA * wrist[1] + (1 - $10cf7727b597bd4a$var$EMA_ALPHA) * $10cf7727b597bd4a$var$clickControl.smoothAvg.y;
    }
    const movement = Math.hypot($10cf7727b597bd4a$var$clickControl.smoothAvg.x - $10cf7727b597bd4a$var$clickControl.fistAverage.x, $10cf7727b597bd4a$var$clickControl.smoothAvg.y - $10cf7727b597bd4a$var$clickControl.fistAverage.y);
    const stable = movement < $10cf7727b597bd4a$var$MOVEMENT_STABLE_PX;
    $10cf7727b597bd4a$var$clickControl.fistAverage = {
        x: $10cf7727b597bd4a$var$clickControl.smoothAvg.x,
        y: $10cf7727b597bd4a$var$clickControl.smoothAvg.y
    };
    // ── Gesture detection ─────────────────────────────────
    const fistDetected = $10cf7727b597bd4a$var$isFist(ann);
    const openPalmDetected = $10cf7727b597bd4a$var$isOpenPalm(ann);
    // ── Visual cursor feedback ────────────────────────────
    const cursor = document.getElementById('virtual-cursor');
    if (cursor) {
        if (fistDetected) {
            cursor.classList.add('cluster'); // red = fist armed
            cursor.classList.remove('open');
        } else {
            cursor.classList.add('open'); // purple = relaxed / open
            cursor.classList.remove('cluster');
        }
    }
    // ── State machine ─────────────────────────────────────
    switch($10cf7727b597bd4a$var$clickControl.state){
        // Waiting for a fist
        case 'idle':
            if (fistDetected && stable) {
                $10cf7727b597bd4a$var$clickControl.state = 'fist';
                $10cf7727b597bd4a$var$clickControl.lastGestureTime = now;
            }
            break;
        // Holding fist – confirm it's intentional, not accidental
        case 'fist':
            if (!fistDetected) {
                $10cf7727b597bd4a$var$clickControl.state = 'idle'; // opened too soon – abort
                break;
            }
            if (!stable) {
                $10cf7727b597bd4a$var$clickControl.lastGestureTime = now; // drifting – restart hold timer
                break;
            }
            if (now - $10cf7727b597bd4a$var$clickControl.lastGestureTime > $10cf7727b597bd4a$var$FIST_STABLE_MS) {
                $10cf7727b597bd4a$var$clickControl.state = 'waitingOpen';
                console.log("[gesture] Fist armed \u2013 open palm to click");
            }
            break;
        // Fist is armed – wait for open palm to fire click
        case 'waitingOpen':
            // Hand went to a neutral pose without opening → disarm
            if (!fistDetected && !openPalmDetected) {
                $10cf7727b597bd4a$var$clickControl.state = 'idle';
                break;
            }
            if (openPalmDetected && now - $10cf7727b597bd4a$var$lastClickTime > $10cf7727b597bd4a$var$COOLDOWN_MS) {
                console.log("[gesture] CLICK TRIGGERED \u2713");
                $10cf7727b597bd4a$var$fireClick();
                $10cf7727b597bd4a$var$lastClickTime = now;
                $10cf7727b597bd4a$var$clickControl.state = 'clicked';
            }
            break;
        // Debounce – wait for neutral pose before allowing next click
        case 'clicked':
            if (!fistDetected && !openPalmDetected) $10cf7727b597bd4a$var$clickControl.state = 'idle';
            break;
    }
}
// ─────────────────────────────────────────────────────────
//  "Open Google" button listener
// ─────────────────────────────────────────────────────────
const $10cf7727b597bd4a$var$openUrl = 'https://www.google.com';
document.getElementById('open-google').addEventListener('click', (e)=>{
    const newTab = window.open($10cf7727b597bd4a$var$openUrl, '_blank', 'noopener,noreferrer');
    if (newTab) newTab.focus();
});
// ─────────────────────────────────────────────────────────
//  Fire synthesised pointer + click events at cursor position
// ─────────────────────────────────────────────────────────
function $10cf7727b597bd4a$var$fireClick() {
    const cursor = document.getElementById('virtual-cursor');
    if (!cursor) return;
    const rect = cursor.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
    const element = document.elementFromPoint(x, y);
    if (!element) return;
    // hover effect for buttons
    if (element?.matches("button, a, [role='button']")) {
        element.classList.add('virtual-hover');
        setTimeout(()=>element.classList.remove('virtual-hover'), 300);
    }
    // simulate real pointer interaction
    const opts = {
        bubbles: true,
        cancelable: true,
        clientX: x,
        clientY: y
    };
    element.dispatchEvent(new MouseEvent('pointerdown', {
        ...opts,
        pointerType: 'mouse'
    }));
    element.dispatchEvent(new MouseEvent('pointerup', {
        ...opts,
        pointerType: 'mouse'
    }));
    element.dispatchEvent(new MouseEvent('click', {
        ...opts,
        view: window
    }));
}


// ─────────────────────────────────────────────────────────
//  gestureForModal.js
//
//  Gesture 1 – "pinch-hold" (middleFinger + thumb ≤ threshold for
//               PINCH_HOLD_MS) → toggles the image modal.
//
//  Gesture 2 – pinkyFinger fingertip hovering over #myImg (in the
//               page, NOT the modal) → shows an overlay
//               caption; moving away hides it.
// ─────────────────────────────────────────────────────────
// ── Tuneable constants ────────────────────────────────────
const $23b79d0787e2d01d$var$PINCH_THRESHOLD = 38; // px – middleFinger-tip to thumb-tip
const $23b79d0787e2d01d$var$PINCH_HOLD_MS = 420; // ms – must hold before firing
const $23b79d0787e2d01d$var$MODAL_COOLDOWN_MS = 900; // ms – debounce between toggles
// ── State ─────────────────────────────────────────────────
let $23b79d0787e2d01d$var$pinchState = {
    active: false,
    startTime: 0,
    fired: false
};
let $23b79d0787e2d01d$var$lastModalToggleTime = 0;
let $23b79d0787e2d01d$var$modalOpen = false;
// ── DOM refs (resolved lazily so the module can be imported early) ──
function $23b79d0787e2d01d$var$getModal() {
    return document.getElementById('myModal');
}
function $23b79d0787e2d01d$var$getCaption() {
    return document.getElementById('caption');
}
function $23b79d0787e2d01d$var$getModalImg() {
    return document.querySelector('.modal-content');
}
function $23b79d0787e2d01d$var$getThumbImg() {
    return document.getElementById('myImg');
}
// ── Ensure the image-hover overlay exists ────────────────
function $23b79d0787e2d01d$var$ensureHoverOverlay() {
    let ov = document.getElementById('gesture-img-overlay');
    if (!ov) {
        ov = document.createElement('div');
        ov.id = 'gesture-img-overlay';
        ov.textContent = "Pinch & hold to open \uD83E\uDD0C ";
        // Inline styles so no extra CSS file is needed (merged into styles.css below)
        Object.assign(ov.style, {
            position: 'absolute',
            bottom: '0',
            left: '0',
            right: '0',
            background: 'linear-gradient(transparent, rgba(0,0,0,0.75))',
            color: '#fff',
            padding: '18px 14px 14px',
            fontSize: 'clamp(0.75rem, 2vw, 1rem)',
            borderRadius: '0 0 10px 10px',
            textAlign: 'center',
            opacity: '0',
            transition: 'opacity 0.25s ease',
            pointerEvents: 'none'
        });
        // The image-container must be position:relative for absolute children
        const container = document.querySelector('.image-container');
        if (container) {
            container.style.position = 'relative';
            container.appendChild(ov);
        }
    }
    return ov;
}
function $23b79d0787e2d01d$export$fc5bd87f75231418(prediction, screenX, screenY) {
    const now = Date.now();
    // ── Fingertip positions (raw, camera space) ───────────
    const pinkyTip = prediction.annotations.pinky[3];
    const thumbTip = prediction.annotations.thumb[3];
    const pinchDist = Math.hypot(pinkyTip[0] - thumbTip[0], pinkyTip[1] - thumbTip[1]);
    const isPinching = pinchDist <= $23b79d0787e2d01d$var$PINCH_THRESHOLD;
    // ── 1. PINCH-HOLD → toggle modal ─────────────────────
    if (isPinching) {
        if (!$23b79d0787e2d01d$var$pinchState.active) {
            $23b79d0787e2d01d$var$pinchState.active = true;
            $23b79d0787e2d01d$var$pinchState.startTime = now;
            $23b79d0787e2d01d$var$pinchState.fired = false;
        }
        const held = now - $23b79d0787e2d01d$var$pinchState.startTime;
        // Show a "charging" visual on the cursor
        const cursor = document.getElementById('virtual-cursor');
        if (cursor) {
            const progress = Math.min(held / $23b79d0787e2d01d$var$PINCH_HOLD_MS, 1);
            cursor.style.setProperty('--pinch-progress', progress.toFixed(2));
            cursor.classList.add('pinching');
        }
        if (!$23b79d0787e2d01d$var$pinchState.fired && held >= $23b79d0787e2d01d$var$PINCH_HOLD_MS) {
            if (now - $23b79d0787e2d01d$var$lastModalToggleTime > $23b79d0787e2d01d$var$MODAL_COOLDOWN_MS) {
                $23b79d0787e2d01d$var$toggleModal();
                $23b79d0787e2d01d$var$lastModalToggleTime = now;
            }
            $23b79d0787e2d01d$var$pinchState.fired = true;
        }
    } else {
        // Released – clean up
        $23b79d0787e2d01d$var$pinchState.active = false;
        $23b79d0787e2d01d$var$pinchState.fired = false;
        const cursor = document.getElementById('virtual-cursor');
        if (cursor) cursor.classList.remove('pinching');
    }
    // ── 2. INDEX HOVER → image caption overlay ───────────
    const overlay = $23b79d0787e2d01d$var$ensureHoverOverlay();
    const thumbImgEl = $23b79d0787e2d01d$var$getThumbImg();
    if (thumbImgEl && overlay && !$23b79d0787e2d01d$var$modalOpen) {
        const rect = thumbImgEl.getBoundingClientRect();
        const inside = screenX >= rect.left && screenX <= rect.right && screenY >= rect.top && screenY <= rect.bottom;
        overlay.style.opacity = inside ? '1' : '0';
    }
}
// ─────────────────────────────────────────────────────────
//  Modal helpers
// ─────────────────────────────────────────────────────────
function $23b79d0787e2d01d$var$toggleModal() {
    const modal = $23b79d0787e2d01d$var$getModal();
    const srcImg = $23b79d0787e2d01d$var$getThumbImg();
    const modalImg = $23b79d0787e2d01d$var$getModalImg();
    const caption = $23b79d0787e2d01d$var$getCaption();
    if (!modal) return;
    if (!$23b79d0787e2d01d$var$modalOpen) {
        // Populate and open
        if (modalImg && srcImg) modalImg.src = srcImg.src;
        /*     if (caption && srcImg) caption.innerHTML = srcImg.alt; */ modal.style.display = 'block';
        $23b79d0787e2d01d$var$modalOpen = true;
        console.log('[gesture] Modal OPENED');
    } else {
        modal.style.display = 'none';
        $23b79d0787e2d01d$var$modalOpen = false;
        console.log('[gesture] Modal CLOSED');
    }
}
// Also wire up the existing close-button & outside-click behaviour
document.addEventListener('DOMContentLoaded', ()=>{
    const modal = $23b79d0787e2d01d$var$getModal();
    if (!modal) return;
    // Close button (×)
    modal.querySelector('.close')?.addEventListener('click', ()=>{
        modal.style.display = 'none';
        $23b79d0787e2d01d$var$modalOpen = false;
    });
    // Click outside image
    modal.addEventListener('click', (e)=>{
        if (e.target === modal) {
            modal.style.display = 'none';
            $23b79d0787e2d01d$var$modalOpen = false;
        }
    });
    // Thumbnail click (mouse / touch fallback)
    $23b79d0787e2d01d$var$getThumbImg()?.addEventListener('click', ()=>{
        if (!$23b79d0787e2d01d$var$modalOpen) $23b79d0787e2d01d$var$toggleModal();
    });
});


const $b03d18f5ace6c282$var$indexCursor = document.getElementById('virtual-cursor');
// ── Device-aware video config ─────────────────────────────
function $b03d18f5ace6c282$var$getVideoConfig() {
    const isLowEnd = navigator.hardwareConcurrency <= 4;
    const isMobile = window.innerWidth < 768;
    return {
        width: isMobile ? Math.min(window.innerWidth, 640) : window.innerWidth,
        height: isMobile ? Math.min(window.innerHeight, 480) : window.innerHeight,
        fps: isLowEnd || isMobile ? 20 : 30
    };
}
async function $b03d18f5ace6c282$var$startDetectionLoop(model, video, videoWidth, videoHeight) {
    async function runDetection() {
        // Draw hand landmarks
        const predictions = await model.estimateHands(video);
        if (predictions !== null && predictions.length > 0) {
            let prediction = predictions[0];
            const indexFingerTipX = prediction.annotations.indexFinger[3][0];
            const indexFingerTipY = prediction.annotations.indexFinger[3][1];
            const thumbX = prediction.annotations.thumb[3][0];
            const thumbY = prediction.annotations.thumb[3][1];
            const pinchDist = Math.hypot(indexFingerTipX - thumbX, indexFingerTipY - thumbY);
            const treshold = 40;
            let pinch = pinchDist <= treshold;
            // ── Scroll ───────────────────────────────────────────
            (0, $2ca412f2b7fd875e$export$8f7e70c35bef16dc)(pinch, predictions);
            // ── Cursor ───────────────────────────────────────────
            $b03d18f5ace6c282$var$indexCursor.style.display = 'none';
            const { screenX: screenX, screenY: screenY } = (0, $e02e324ad509ad30$export$4d7186f747f2fbe6)(indexFingerTipX, indexFingerTipY, videoWidth, videoHeight);
            $b03d18f5ace6c282$var$indexCursor.style.display = 'block';
            // ── Click gesture (five-finger cluster → open palm) ──
            (0, $10cf7727b597bd4a$export$388ce54039214433)(prediction);
            // ── Modal gesture (pinch-hold) + image hover overlay ─
            if (screenX && screenY && !isNaN(screenX) && !isNaN(screenY)) (0, $23b79d0787e2d01d$export$fc5bd87f75231418)(prediction, screenX, screenY);
        }
        requestAnimationFrame(runDetection);
    }
    //model = await handpose.load();
    runDetection();
}
// ── Bootstrap ─────────────────────────────────────────────
async function $b03d18f5ace6c282$var$main() {
    const cfg = $b03d18f5ace6c282$var$getVideoConfig();
    const video = await (0, $ff61dd1a091f4213$export$d2b008984942555e)(cfg.width, cfg.height, cfg.fps);
    // Dimensions are definitely available here
    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;
    // Load model AFTER video is ready, then kick off the loop
    const model = await handpose.load();
    $b03d18f5ace6c282$var$startDetectionLoop(model, video, videoWidth, videoHeight);
}
$b03d18f5ace6c282$var$main();


//# sourceMappingURL=web_pose_app.d6922e06.js.map
